<style scoped>
  .orders-table-header {
    border-bottom: 1px solid var(--color-border);
    padding-right: 5px;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: left;
    font-size: 12px;
    color: var(--color-text-dark);
  }
  .coin-icon {
    top: 3px;
    position: relative;
    margin-right: 5px;
  }

  .orders-table {
    border-collapse: collapse;
    width: 96%;
    margin-bottom: 20px;
    margin-left: 15px;
    font-size: 12px;
  }
  .tablerow {
    height: 32px;
  }
  .symbol {
    font-size: 18px;
    font-weight: normal;
    padding-top: 5px;
    margin-left: 15px;
  }
  .bot-name {
    color: var(--color-text-dark);
    font-weight: bold;
    padding-bottom: 5px;
    font-size: 16px;
    margin-left: 15px;
  }
  .right-padding {
    padding-right: 5px;
  }
  td {
    /*border: 1px solid mediumturquoise;*/
  }
  div {
    /*border: 1px solid mediumturquoise;*/
  }

  .headerorders {
    font-size: 12px;
    color: var(--color-text-dark);
    font-weight: bold;
    padding-left: 30px;
    padding-right: 5px;
  }

  .numberorders {
    font-size: 14px;
  }

  .red {
    color:var(--color-danger-light);
  }

  .green {
    color: var(--color-success-light);
  }

  @media all and (max-width: 576px) {
    .display-none {
      display: none;
    }
  }
</style>

<template>
  <div>
    <Modal :value="show" width="1100" @input="$emit('on-cancel', $event)">
      <div class="symbol">
        <CoinIcon class="coin-icon" :symbol="symbol" />
        <span>{{ returnSymbol() }}</span>
        <span class="headerorders">{{ $text.tr('ОБЩЕЕ КОЛ-ВО') }}</span><span class="numberorders">{{ totalQty }} {{ this.symbol.split('_')[0] }}</span>
        <span class="headerorders">{{ $text.tr('ОБЩАЯ СУММА') }}</span><span class="numberorders">{{ totalAmount }}  {{ this.symbol.split('_')[1] }}</span>
      </div>
      <div class="bot-name"> {{ comment }}</div>
      <table class="orders-table">
        <tr>
          <th class="orders-table-header" style="width: 150px">{{ $text.tr('ДАТА') }}</th>
          <th class="orders-table-header">{{ $text.tr('ТИП') }}</th>
          <th class="orders-table-header">{{ $text.tr('НАПРАВЛЕНИЕ') }}</th>
          <th class="orders-table-header">{{ $text.tr('КОЛ-ВО') }}</th>
          <th class="orders-table-header">{{ $text.tr('ЦЕНА') }}</th>
          <th class="orders-table-header">{{ $text.tr('СУММА') }}</th>
          <th class="orders-table-header">{{ $text.tr('КОМИССИЯ БИРЖИ') }}</th>
          <th class="orders-table-header display-none">{{ $text.tr('ПРИБЫЛЬ')}}</th>
          <th class="orders-table-header"></th>
          <th class="orders-table-header">{{ $text.tr('СТАТУС') }}</th>
        </tr>
        <template v-for="(order, index) in orders">
          <tr :key="'order-' + index" class="tablerow">
            <td class="right-padding">
              {{ localTime(order.Ts) }}
            </td>
            <td class="right-padding">
              <div v-if="order.Market">MARKET</div>
              <div v-else>LIMIT</div>
            </td>
            <td class="right-padding">
              <div v-if="order.Side === 'B'" style="color: var(--color-success-light)">{{ $text.tr('ПОКУПКА') }}</div>
              <div v-if="order.Side === 'S'" style="color:var(--color-danger-light)">{{ $text.tr('ПРОДАЖА') }}</div>
            </td>
            <td class="right-padding">
              <div v-if="order.Status === 'EXC' || order.Qty === order.Filled">{{ order.Filled }}</div>
              <div v-else>{{ order.Filled }} / {{ order.Qty }}</div>
            </td>
            <td class="right-padding">
              {{ order.Price }}
            </td>
            <td class="right-padding">
              {{ returnAmount(order.Qty, order.Price) }}
            </td>
            <td class="right-padding">
              <div v-if="order.FeeAsset != ''">
                {{ order.Fee }} {{ order.FeeAsset }}
              </div>
            </td>
            <td class="right-padding display-none">
              <div v-if="order.Profit !== '0'" :class="{'red' : parseFloat(order.Profit) < 0, 'green' : parseFloat(order.Profit) >= 0}">
                {{ order.Profit }}
              </div>
            </td>
            <td class="right-padding">
              <div v-if="returnType(order.Type) !==''" style="margin-right: 20px">
                {{ returnType(order.Type) }}
              </div>
            </td>
            <td>
              {{ returnStatus(order.Status, order.Filled) }}
            </td>
          </tr>
        </template>
      </table>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import CoinIcon from '@/components/common/CoinIcon.vue'
import Decimal from 'decimal.js'
import Util from '@/util/util'

export default {
  components: { CoinIcon },
  name: 'BotOrdersModal',
  props: ['show', 'orders', 'comment', 'symbol', 'side'],
  data () {
    return {
    }
  },
  computed: {
    totalQty () {
      return this.excOrders.reduce((total, obj) => total.add(obj.Qty), new Decimal(0))
    },
    totalAmount () {
      return this.excOrders.reduce((total, obj) => total.add(new Decimal(obj.Qty).mul(obj.Price)), new Decimal(0))
    },
    excOrders () {
      if (this.orders) {
        return this.orders.filter(obj => obj.Side === this.side)
      } else {
        return []
      }
    }
  },
  methods: {
    returnAmount (qty, price) {
      const filt = this.$store.state.data.symbolsfilter[this.symbol]
      if (!filt) {
        return
      }
      const amountDec = parseFloat(filt.PriceDec) + parseFloat(filt.QtyDec)
      const amount = new Decimal(qty).mul(new Decimal(price)).toDP(amountDec).toString()
      return amount
    },

    returnStatus (status, filled) {
      if (status === 'EXC') {
        return this.$text.tr('ИСПОЛНЕН')
      } else if (status === 'ACT') {
        if (new Decimal(filled).greaterThan(0)) {
          return this.$text.tr('ЧАСТИЧНО ИСПОЛНЕН')
        }
        return this.$text.tr('РАЗМЕЩЕН')
      } else if (status === 'CNL') {
        return this.$text.tr('ОТМЕНЕН')
      }
      return status
    },

    returnType (type) {
      return Util.typeString(type)
    },

    returnSymbol () {
      const assets = this.symbol.split('_')
      return assets[0] + '/' + assets[1]
    },

    localTime (utctime) {
      return new Date(utctime).toLocaleString('ru-RU').replace(',', '')
    }
  }
}
</script>
